var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMoneyDollarCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-dollar-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.66815 14.6688C4.98624 14.6688 2.00146 11.684 2.00146 8.0021C2.00146 4.32022 4.98624 1.33545 8.66815 1.33545C12.35 1.33545 15.3348 4.32022 15.3348 8.0021C15.3348 11.684 12.35 14.6688 8.66815 14.6688ZM8.66815 13.3354C11.6137 13.3354 14.0015 10.9476 14.0015 8.0021C14.0015 5.0566 11.6137 2.66878 8.66815 2.66878C5.72261 2.66878 3.3348 5.0566 3.3348 8.0021C3.3348 10.9476 5.72261 13.3354 8.66815 13.3354ZM6.3348 9.33543H10.0015C10.1855 9.33543 10.3348 9.18623 10.3348 9.0021C10.3348 8.81803 10.1855 8.66876 10.0015 8.66876H7.33481C6.41432 8.66876 5.66813 7.92256 5.66813 7.0021C5.66813 6.08164 6.41432 5.33545 7.33481 5.33545H8.00148V4.00212H9.33481V5.33545H11.0015V6.66876H7.33481C7.1507 6.66876 7.00146 6.81803 7.00146 7.0021C7.00146 7.18623 7.1507 7.33543 7.33481 7.33543H10.0015C10.9219 7.33543 11.6681 8.08163 11.6681 9.0021C11.6681 9.92256 10.9219 10.6688 10.0015 10.6688H9.33481V12.0021H8.00148V10.6688H6.3348V9.33543Z",
    fill: "#A3A3A3"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoneyDollarCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/money-dollar-circle.85cdefd2.svg";
export { ForwardRef as ReactComponent };